import React from 'react';
import { Box, Typography } from '@mui/material';
import ActivityJournal from '../components/ActivityJournal';

interface CertificatesPageProps {
  // Add any props needed
}

const CertificatesPage: React.FC<CertificatesPageProps> = () => {
  return (
    <Box sx={{ flex: 1, p: 3 }}>
      {/* Certificates Content */}
      <ActivityJournal />
    </Box>
  );
};

export default CertificatesPage;